import React from 'react';
import { Award, Trophy } from 'lucide-react';

const AwardsHonors = () => {
  const awards = [
    {
      title: 'Member of the Order of the British Empire (MBE)',
      year: '2020',
      issuedBy: 'Her Majesty The Queen',
      description: 'Awarded for outstanding contributions to education and community service during the COVID-19 pandemic, specifically for delivering 15,000 free school meals to vulnerable children.',
      image: 'https://customer-assets.emergentagent.com/job_5e4deebd-59c3-4178-8957-af382f8caac5/artifacts/ke1mawgl_IMG_7647%203%202.JPG',
      imageAlt: 'Zane Powles at Windsor Castle holding MBE medal',
      major: true
    },
    {
      title: 'Most Inspirational Primary School Teacher of the Year',
      year: '2019',
      issuedBy: 'Golden Apples Education Awards',
      description: 'Recognised by the local community and education sector for exceptional dedication, innovative teaching practices, and positive impact on students\' lives.',
      image: 'https://customer-assets.emergentagent.com/job_5e4deebd-59c3-4178-8957-af382f8caac5/artifacts/irt8ebem_IMG_8648%20%281%29.JPG',
      imageAlt: 'Zane Powles receiving Golden Apples Education Award',
      major: true
    }
  ];

  const certifications = [
    {
      title: 'Team Teach: Restraint Training',
      level: 'Expert Trainer SEMH Programs',
      years: '2021, 2024'
    },
    {
      title: 'Play Therapy - Sunshine Circles',
      level: 'Certified Play Therapist',
      years: '2024'
    },
    {
      title: 'Zippy, Apple and Passport',
      level: 'Mental Health & Wellbeing Programs',
      years: '2024'
    },
    {
      title: 'Safeguarding Level 2',
      level: 'Child Protection',
      years: '2021, 2024'
    }
  ];

  return (
    <section id="awards-honors" className="awards-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Awards & Honours</h2>
          <p className="section-subtitle">Recognition for excellence in educational leadership and community service</p>
        </div>

        <div className="awards-grid">
          {awards.map((award, index) => (
            <div key={index} className={`award-card ${award.major ? 'major-award' : ''}`}>
              <div className="award-image-container">
                <img 
                  src={award.image} 
                  alt={award.imageAlt}
                  className="award-image"
                />
              </div>
              <div className="award-content">
                <div className="award-icon">
                  <Award size={32} />
                </div>
                <h3 className="award-title">{award.title}</h3>
                <div className="award-meta">
                  <span className="award-year">{award.year}</span>
                  <span className="award-divider">•</span>
                  <span className="award-issuer">{award.issuedBy}</span>
                </div>
                <p className="award-description">{award.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="certifications-section">
          <h3 className="subsection-title">
            <Trophy size={24} />
            Professional Certifications
          </h3>
          <div className="certifications-grid">
            {certifications.map((cert, index) => (
              <div key={index} className="certification-card">
                <h4>{cert.title}</h4>
                <p className="cert-level">{cert.level}</p>
                <p className="cert-years">{cert.years}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="expertise-section">
          <h3 className="subsection-title">Areas of Expertise</h3>
          <div className="expertise-grid">
            <div className="expertise-card">
              <h4>Educational Leadership</h4>
              <p>Strategic school operations, curriculum development, and staff mentorship across international contexts</p>
            </div>
            <div className="expertise-card">
              <h4>SEND & SEMH Support</h4>
              <p>Specialised interventions for Special Educational Needs and Social, Emotional & Mental Health challenges</p>
            </div>
            <div className="expertise-card">
              <h4>Behavioural Management</h4>
              <p>Expert trainer in behavioural strategies, de-escalation techniques, and inclusive classroom practices</p>
            </div>
            <div className="expertise-card">
              <h4>Safeguarding & Inclusion</h4>
              <p>Designated Safeguarding Lead with comprehensive child protection and welfare expertise</p>
            </div>
            <div className="expertise-card">
              <h4>Policy Development</h4>
              <p>Government-level policy creation, EHCAR review, and educational standards implementation</p>
            </div>
            <div className="expertise-card">
              <h4>International Experience</h4>
              <p>Leadership roles across UK, Panama, and Cayman Islands with diverse cultural competencies</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AwardsHonors;